<div id="navigation-bar" class="navigation-bar" #navigationBar>
  <dap-lib-button
    buttonSize="large"
    class="stretch"
    iconName="arrow-sm-left"
    iconPosition="left"
    variant="tertiary"
    data-cy="selection-page-previous"
    data-analytics="selection-navigation_back"
    [routerLink]="previousButtonNavigationDetails.routerLink"
    tabindex="-1"
  >
    {{ previousButtonNavigationDetails.translationKey | translate: previousButtonNavigationDetails.translationParams }}
  </dap-lib-button>
  <dap-lib-button
    buttonSize="large"
    class="stretch"
    variant="secondary"
    iconPosition="right"
    iconName="arrow-sm-right"
    data-cy="selection-page-next"
    data-analytics="selection-navigation_next"
    [routerLink]="nextButtonNavigationDetails.routerLink"
    tabindex="-1"
  >
    {{ nextButtonNavigationDetails.translationKey | translate: nextButtonNavigationDetails.translationParams }}
  </dap-lib-button>
</div>

<div
  *dapLibHideForBreakpoint="'for-XSmall-Down'"
  class="navigation-bar-fixed"
  [class.show]="fixedNavigationBarShouldBeVisible$ | async"
  [class.animated]="fixedNavigationBarShouldAnimate$ | async"
>
  <div>
    <dap-lib-button
      buttonSize="medium"
      class="stretch"
      iconName="arrow-sm-left"
      iconPosition="left"
      variant="tertiary"
      data-analytics="selection-navigation_back"
      [routerLink]="previousButtonNavigationDetails.routerLink"
      tabindex="-1"
    >
      {{
        previousButtonNavigationDetails.translationKey | translate: previousButtonNavigationDetails.translationParams
      }}
    </dap-lib-button>
    <dap-lib-button
      buttonSize="medium"
      class="stretch"
      variant="secondary"
      iconPosition="right"
      iconName="arrow-sm-right"
      data-analytics="selection-navigation_next"
      [routerLink]="nextButtonNavigationDetails.routerLink"
      tabindex="-1"
    >
      {{ nextButtonNavigationDetails.translationKey | translate: nextButtonNavigationDetails.translationParams }}
    </dap-lib-button>
  </div>
</div>
